import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from "redux-form";
import registration from './registration/registration';
import account from './account/account';
import jobs from './jobs/jobs';
import members from './members/members';
//import events from './events/events';
import requests from './requests/requests';
import profileCombined from '../../client/components/site/features/profile/reducers';
import purchases from "./basket/purchases";
import authentication from './authentication/authentication';
import courses from './training/courses/courses';
import webinars from './training/webinars/webinars';
import podcasts from './training/podcasts/podcasts';
import forums from './forums/forums';
import transactions from './transactions/transactions';
import networking from './networking/networking';
import { common, expertise, pagination, industries, markets, sectors, search, countries, site_notifications } from './common';
import notifications from './notifications/notifications';
import media from './media/media';
import documents from './documents/documents';
import BTexpertise from './profile/BTexpertise';
import ratings from './ratings/ratings';
import googledfp from '../components/common/adverts/googleDFP/lib/reducers';
import todoList from './todo_list/todo_list';

const appReducer = combineReducers( {
    googledfp,
    registration,
    account,
    jobs,
    //events,
    requests,
    profile: profileCombined,
    purchases,
    authentication,
    courses,
    webinars,
    podcasts,
    forums,
    transactions,
    networking,
    expertise,
    pagination,
    industries,
    markets,
    sectors,
    search,
    notifications,
    site_notifications,
    members,
    countries,
    common,
    BTexpertise,
    media,
    documents,
    ratings,
    todoList,
    form: formReducer,
    routing: routerReducer
} );

const rootReducer = ( state, action ) => {
    if( action.type === "LOGOUT_USER" ) {
        state = undefined;
    }

    return appReducer( state, action );
};

export default rootReducer;


// WEBPACK FOOTER //
// src/client/reducers/index.js